import { Box, Img, Flex } from '@chakra-ui/react'
import React from 'react'
import { Outlet } from 'react-router-dom'

import MenuLinks from './MenuLinks'
import NavBar from '../Navbar'
import logo from "../../assets/Hervest-logo.svg"
const MenuSidebar = () => {
    return (
        <Box>
            <Box bg="white" 
                w="15rem"
                display={["none", "none","block"]}
                flexShrink="0"
                h="100vh"
                zIndex="1000"
                position="fixed"
                overflowX="hidden"
                top="0" 
                borderRight="1px solid"
                borderRightColor="gray.100">
                <Flex align="center" justify="center" py={8}>
                    <Img src={logo} objectFit="contain" w="60%" />
                </Flex>
                <Box pt="2" >
                    <MenuLinks />
                </Box>
            </Box>
            <Box ml={[0, 0, "15rem"]}>
                <NavBar />
                <Box p={4}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}

export default MenuSidebar
